<div *ngFor="let job of jobs">
    <div *ngIf="job.jobType == AsyncJobType.CalculateJFCDistributions">
        Calculate JFC distributions for file {{job.content.originalFileName}}:
        <div *ngIf="job.content.outputFileName">
            Output: {{job.content.outputFileName}}
            <rc-generic-button 
                label="Distributions List"
                iconImg="download"
                borderStyle="outline"
                size="small"
                (clickHandler)="downloadJFCFile(job.content.category, job.content.outputFileName)" />
        </div>
        <div *ngIf="job.content.errorFileName">
            <rc-generic-button 
            label="Error List"
            iconImg="download"
            borderStyle="outline"
            size="small"
            (clickHandler)="downloadJFCFile(job.content.category, job.content.errorFileName)" />
        </div>
    </div>
    <br /> <br />
</div>
